import DOMPurify from "dompurify";

// IM's student/teacher HTML is third-party content injected via
// dangerouslySetInnerHTML, so it must be sanitized first. DOMPurify's default
// allow-list already covers everything this content needs — verified
// empirically against the fixture — so no ADD_TAGS/ADD_ATTR overrides:
//   - <img src alt> (figures hosted on cms-assets.illustrativemathematics.org)
//   - <span class="..."> (MathJax's `\(...\)` delimiters live in a
//     `<span class="math">`, and DOMPurify keeps `class` by default)
//   - ordinary text-formatting tags (p, br, strong, em, ul, ol, li, h1-h4,
//     table/thead/tbody/tr/td/th)
export const sanitizeImHtml = (html) => (html ? DOMPurify.sanitize(html) : "");
